
{
  "familyId": "GET-BREUK-UITBREIDEN",
  "questions": [
    {
      "id": "GET-BREUK-UITBREIDEN-001",
      "familyId": "GET-BREUK-UITBREIDEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_uitbreiden",
      "questionType": "multiple_choice",
      "question": "Een bakker verdeelt deeg in gelijke stukken. Hij heeft ²⁄₃ van het deeg nodig, maar wil het in twaalfden uitdrukken. Wat wordt de teller?",
      "options": ["8", "6", "4", "9"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 2,
            "denominator": 3,
            "equivalentNumerator": 8,
            "equivalentDenominator": 12,
            "label": "²⁄₃ = ⁸⁄₁₂"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuken uitbreiden",
            "content": "Bij uitbreiden vermenigvuldig je teller EN noemer met hetzelfde getal. De waarde van de breuk verandert niet. Zoek de factor: nieuwe noemer ÷ oude noemer.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_uitbreiden_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2
      },
      "feedback": {
        "explanationText": "Vermenigvuldig teller en noemer met hetzelfde getal. De noemer moet van 3 naar 12: 12 ÷ 3 = 4, dus vermenigvuldig met 4. Teller: 2 × 4 = 8. Dus ²⁄₃ = ⁸⁄₁₂. Controleer: 8 ÷ 12 = 0,666... = 2 ÷ 3 ✓.",
        "solutionSteps": [
          "Noemer: van 3 naar 12 → factor = 12 ÷ 3 = 4",
          "Teller: 2 × 4 = 8",
          "²⁄₃ = ⁸⁄₁₂",
          "Controleer: 8 ÷ 12 = 0,666... = 2 ÷ 3 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! ²⁄₃ = ⁸⁄₁₂. De noemer × 4, dus de teller ook × 4: 2 × 4 = 8.",
          "1": "Je dacht waarschijnlijk dat je alleen de noemer vermenigvuldigt. Maar ⁶⁄₁₂ = ½, niet ²⁄₃. Onthoud: je moet teller EN noemer met hetzelfde getal vermenigvuldigen.",
          "2": "Je dacht waarschijnlijk dat je de factor bij de teller optelt. Maar 2 + 2 = 4 is niet hoe uitbreiden werkt. Onthoud: je moet vermenigvuldigen, niet optellen: 2 × 4 = 8.",
          "3": "Je dacht waarschijnlijk dat je de noemer bij de teller optelt. Maar ⁹⁄₁₂ = ¾, niet ²⁄₃. Onthoud: bij uitbreiden vermenigvuldig je, je telt niet op."
        }
      }
    },
    {
      "id": "GET-BREUK-UITBREIDEN-002",
      "familyId": "GET-BREUK-UITBREIDEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_uitbreiden",
      "questionType": "multiple_choice",
      "question": "Welke breuk is gelijk aan ¾ maar heeft noemer 20?",
      "options": ["¹⁵⁄₂₀", "¹²⁄₂₀", "⁸⁄₂₀", "¹⁶⁄₂₀"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "equivalentNumerator": 15,
            "equivalentDenominator": 20,
            "label": "¾ = ¹⁵⁄₂₀"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Uitbreiden: zoek de factor",
            "content": "Deel de nieuwe noemer door de oude noemer. Dat is de factor waarmee je teller EN noemer vermenigvuldigt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_uitbreiden_kwarten",
      "variantIndex": 2,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.breuk-uitbreiden-factor-fout", "label": "Verkeerde factor gebruikt (× 4 i.p.v. × 5)", "optionIndex": 1 },
          { "id": "get.breuk-uitbreiden-teller-fout", "label": "Verkeerde teller gebruikt", "optionIndex": 2 },
          { "id": "get.breuk-uitbreiden-teller-als-factor", "label": "Teller verwisseld met factor", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Zoek de vermenigvuldigingsfactor. Noemer: 4 → 20. Factor: 20 ÷ 4 = 5. Teller: 3 × 5 = 15. Dus ¾ = ¹⁵⁄₂₀. Controleer: 15 ÷ 20 = 0,75 = 3 ÷ 4 ✓.",
        "solutionSteps": [
          "Noemer: 4 → 20 → factor = 20 ÷ 4 = 5",
          "Teller: 3 × 5 = 15",
          "¾ = ¹⁵⁄₂₀"
        ],
        "distractorExplanations": {
          "0": "Goed! ¾ = ¹⁵⁄₂₀. Factor = 5, dus 3 × 5 = 15.",
          "1": "Je dacht waarschijnlijk dat de factor 4 is. Maar 20 ÷ 4 = 5, niet 4. Onthoud: deel de nieuwe noemer door de oude noemer om de factor te vinden.",
          "2": "Je dacht waarschijnlijk dat 2 × 4 = 8 de teller is. Maar de teller is 3, niet 2. Onthoud: 3 × 5 = 15.",
          "3": "Je dacht waarschijnlijk dat 4 × 4 = 16 de teller is. Maar de teller is 3, niet 4. Onthoud: vermenigvuldig de teller (3) met de factor (5)."
        }
      }
    },
    {
      "id": "GET-BREUK-UITBREIDEN-003",
      "familyId": "GET-BREUK-UITBREIDEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_uitbreiden",
      "questionType": "multiple_choice",
      "question": "Je wilt ⅗ en ½ gelijknamig maken. Welke noemer gebruik je?",
      "options": ["10", "7", "15", "5"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gelijknamig maken",
            "content": "Zoek het kleinste gemene veelvoud (KGV) van de noemers. Dat is het kleinste getal dat door beide noemers deelbaar is.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_uitbreiden_gelijknamig",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.breuk-noemers-optellen", "label": "Noemers opgeteld i.p.v. KGV gezocht", "optionIndex": 1 },
          { "id": "get.breuk-noemers-vermenigvuldigen-fout", "label": "Noemer niet deelbaar door beide", "optionIndex": 2 },
          { "id": "get.breuk-uitbreiden-niet-toegepast", "label": "Niet uitgebreid — oude noemer behouden", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Zoek het kleinste gemene veelvoud (KGV) van de noemers 5 en 2. Veelvouden van 5: 5, 10, 15, 20... Veelvouden van 2: 2, 4, 6, 8, 10... Het KGV = 10. Dus ⅗ = ⁶⁄₁₀ en ½ = ⁵⁄₁₀.",
        "solutionSteps": [
          "Noemers zijn 5 en 2",
          "Veelvouden van 5: 5, 10, 15...",
          "Veelvouden van 2: 2, 4, 6, 8, 10...",
          "KGV = 10",
          "⅗ = ⁶⁄₁₀ en ½ = ⁵⁄₁₀"
        ],
        "distractorExplanations": {
          "0": "Goed! KGV(5, 2) = 10. Beide breuken kunnen uitgebreid worden naar noemer 10.",
          "1": "Je dacht waarschijnlijk dat je de noemers optelt. Maar 5 + 2 = 7, en 7 is geen veelvoud van 5 of 2. Onthoud: je zoekt het KGV, niet de som.",
          "2": "Je dacht waarschijnlijk dat 15 werkt. Maar 15 is een veelvoud van 5 (3 × 5), maar niet van 2 (15 is oneven). Onthoud: de noemer moet door beide deelbaar zijn.",
          "3": "Je dacht waarschijnlijk dat 5 al goed is. Maar ½ kun je niet uitbreiden naar noemer 5 (5 is niet deelbaar door 2). Onthoud: je hebt een noemer nodig die door beide deelbaar is."
        }
      }
    },
    {
      "id": "GET-BREUK-UITBREIDEN-004",
      "familyId": "GET-BREUK-UITBREIDEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_uitbreiden",
      "questionType": "multiple_choice",
      "question": "Een apotheker meet ⅙ van een vloeistof af. Op de maatbeker staan achttienden. Wat is de nieuwe breuk?",
      "options": ["³⁄₁₈", "²⁄₁₈", "⁶⁄₁₈", "¹⁄₁₈"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 6,
            "equivalentNumerator": 3,
            "equivalentDenominator": 18,
            "label": "⅙ = ³⁄₁₈"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Uitbreiden: stap voor stap",
            "content": "1. Zoek de factor: nieuwe noemer ÷ oude noemer. 2. Vermenigvuldig teller EN noemer met die factor.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_uitbreiden_zesden",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.breuk-uitbreiden-factor-fout", "label": "Verkeerde factor gebruikt", "optionIndex": 1 },
          { "id": "get.breuk-uitbreiden-teller-fout", "label": "Teller met verkeerde factor vermenigvuldigd", "optionIndex": 2 },
          { "id": "get.breuk-uitbreiden-teller-niet-vermenigvuldigd", "label": "Teller niet vermenigvuldigd, alleen noemer aangepast", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Vermenigvuldig teller en noemer met dezelfde factor. Noemer: 6 → 18. Factor: 18 ÷ 6 = 3. Teller: 1 × 3 = 3. Dus ⅙ = ³⁄₁₈.",
        "solutionSteps": [
          "Noemer: 6 → 18 → factor = 18 ÷ 6 = 3",
          "Teller: 1 × 3 = 3",
          "⅙ = ³⁄₁₈"
        ],
        "distractorExplanations": {
          "0": "Goed! ⅙ = ³⁄₁₈. Factor = 3, dus 1 × 3 = 3.",
          "1": "Je dacht waarschijnlijk dat de factor 2 is. Maar 18 ÷ 6 = 3, niet 2. Onthoud: deel de nieuwe noemer door de oude noemer.",
          "2": "Je dacht waarschijnlijk dat de noemer de teller wordt. Maar de teller is 1, niet 6. Onthoud: 1 × 3 = 3, niet 6 × 3 = 18.",
          "3": "Je dacht waarschijnlijk dat de teller niet verandert. Maar bij uitbreiden moet je de teller ook vermenigvuldigen. Onthoud: 1 × 3 = 3, niet 1."
        }
      }
    },
    {
      "id": "GET-BREUK-UITBREIDEN-005",
      "familyId": "GET-BREUK-UITBREIDEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_uitbreiden",
      "questionType": "multiple_choice",
      "question": "Welke bewerking gebruik je bij het uitbreiden van een breuk?",
      "options": [
        "teller en noemer vermenigvuldigen met hetzelfde getal",
        "teller en noemer optellen met hetzelfde getal",
        "alleen de noemer vermenigvuldigen",
        "teller en noemer door hetzelfde getal delen"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 2,
            "equivalentNumerator": 3,
            "equivalentDenominator": 6,
            "label": "Voorbeeld: $\\frac{1}{2}$ = $\\frac{3}{6}$ (× 3)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Uitbreiden vs. vereenvoudigen",
            "content": "Uitbreiden = teller EN noemer vermenigvuldigen met hetzelfde getal (noemer wordt groter). Vereenvoudigen = teller EN noemer delen door hetzelfde getal (noemer wordt kleiner).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_uitbreiden_begrip",
      "variantIndex": 5,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.breuk-uitbreiden-optellen-ipv-vermenigvuldigen", "label": "Optellen i.p.v. vermenigvuldigen", "optionIndex": 1 },
          { "id": "get.breuk-alleen-noemer-aangepast", "label": "Alleen noemer aangepast", "optionIndex": 2 },
          { "id": "get.breuk-uitbreiden-vs-vereenvoudigen", "label": "Uitbreiden verward met vereenvoudigen", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Bij uitbreiden vermenigvuldig je teller EN noemer met hetzelfde getal. De waarde van de breuk verandert niet. Voorbeeld: ½ × ³⁄₃ = ³⁄₆. De breuk ziet er anders uit, maar is even groot.",
        "solutionSteps": [
          "Uitbreiden = vermenigvuldigen",
          "Teller EN noemer × hetzelfde getal",
          "Voorbeeld: ½ × ³⁄₃ = ³⁄₆",
          "De waarde verandert niet"
        ],
        "distractorExplanations": {
          "0": "Goed! Bij uitbreiden vermenigvuldig je teller en noemer met hetzelfde getal. Zo blijft de waarde gelijk.",
          "1": "Je dacht waarschijnlijk dat je optelt. Maar als je bij ½ teller en noemer met 2 optelt, krijg je ³⁄₄ — dat is een andere waarde! Onthoud: bij vermenigvuldigen blijft de waarde gelijk: ²⁄₄ = ½ ✓.",
          "2": "Je dacht waarschijnlijk dat je alleen de noemer aanpast. Maar als je alleen de noemer vermenigvuldigt, verandert de waarde van de breuk. Onthoud: je moet BEIDE aanpassen.",
          "3": "Je dacht waarschijnlijk dat delen hetzelfde is als uitbreiden. Maar delen is vereenvoudigen, niet uitbreiden. Onthoud: uitbreiden = vermenigvuldigen (noemer groter), vereenvoudigen = delen (noemer kleiner)."
        }
      }
    },
    {
      "id": "GET-BREUK-UITBREIDEN-006",
      "familyId": "GET-BREUK-UITBREIDEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_uitbreiden",
      "questionType": "fill_in",
      "question": "Breid $\\frac{1}{3}$ uit naar zesden. Wat wordt de teller? Typ het getal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["2"],
        "caseSensitive": false,
        "placeholder": "?"
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 3,
            "equivalentNumerator": 2,
            "equivalentDenominator": 6,
            "label": "$\\frac{1}{3}$ = $\\frac{?}{6}$"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Uitbreiden: zoek de factor",
            "content": "Nieuwe noemer ÷ oude noemer = factor. 6 ÷ 3 = 2. Vermenigvuldig de teller ook met 2: 1 × 2 = 2.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_uitbreiden_fill_basis",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Factor: 6 ÷ 3 = 2. Teller: 1 × 2 = 2. Dus $\\frac{1}{3}$ = $\\frac{2}{6}$.",
        "solutionSteps": [
          "Noemer: 3 → 6, factor = 6 ÷ 3 = 2",
          "Teller: 1 × 2 = 2",
          "$\\frac{1}{3}$ = $\\frac{2}{6}$"
        ]
      }
    },
    {
      "id": "GET-BREUK-UITBREIDEN-007",
      "familyId": "GET-BREUK-UITBREIDEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_uitbreiden",
      "questionType": "fill_in",
      "question": "Breid $\\frac{2}{5}$ uit naar tienden. Wat wordt de teller? Typ het getal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["4"],
        "caseSensitive": false,
        "placeholder": "?"
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 2,
            "denominator": 5,
            "equivalentNumerator": 4,
            "equivalentDenominator": 10,
            "label": "$\\frac{2}{5}$ = $\\frac{?}{10}$"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Uitbreiden naar tienden",
            "content": "Factor: 10 ÷ 5 = 2. Teller: 2 × 2 = 4. Dus $\\frac{2}{5}$ = $\\frac{4}{10}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_uitbreiden_fill_tienden",
      "variantIndex": 7,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Factor: 10 ÷ 5 = 2. Teller: 2 × 2 = 4. Dus $\\frac{2}{5}$ = $\\frac{4}{10}$.",
        "solutionSteps": [
          "Noemer: 5 → 10, factor = 10 ÷ 5 = 2",
          "Teller: 2 × 2 = 4",
          "$\\frac{2}{5}$ = $\\frac{4}{10}$"
        ]
      }
    },
    {
      "id": "GET-BREUK-UITBREIDEN-008",
      "familyId": "GET-BREUK-UITBREIDEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_uitbreiden",
      "questionType": "fill_in",
      "question": "Breid $\\frac{3}{4}$ uit naar twintigsten. Wat wordt de teller? Typ het getal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["15"],
        "caseSensitive": false,
        "placeholder": "?"
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "equivalentNumerator": 15,
            "equivalentDenominator": 20,
            "label": "$\\frac{3}{4}$ = $\\frac{?}{20}$"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Uitbreiden: stap voor stap",
            "content": "Factor: 20 ÷ 4 = 5. Teller: 3 × 5 = 15. Dus $\\frac{3}{4}$ = $\\frac{15}{20}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_uitbreiden_fill_complex",
      "variantIndex": 8,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Factor: 20 ÷ 4 = 5. Teller: 3 × 5 = 15. Dus $\\frac{3}{4}$ = $\\frac{15}{20}$.",
        "solutionSteps": [
          "Noemer: 4 → 20, factor = 20 ÷ 4 = 5",
          "Teller: 3 × 5 = 15",
          "$\\frac{3}{4}$ = $\\frac{15}{20}$"
        ]
      }
    },
    {
      "id": "GET-BREUK-UITBREIDEN-FEM-001",
      "familyId": "GET-BREUK-UITBREIDEN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_uitbreiden",
      "questionType": "fraction_equivalence_match",
      "question": "Verbind elke breuk met zijn gelijkwaardige uitbreiding.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "fractionEquivalenceMatch": {
          "pairs": [
            {
              "fraction": { "numerator": 1, "denominator": 2, "visualType": "bar" },
              "equivalent": "4/8"
            },
            {
              "fraction": { "numerator": 2, "denominator": 3, "visualType": "bar" },
              "equivalent": "4/6"
            },
            {
              "fraction": { "numerator": 3, "denominator": 4, "visualType": "bar" },
              "equivalent": "6/8"
            }
          ]
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gelijkwaardige breuken matchen",
            "content": "Vermenigvuldig teller én noemer met hetzelfde getal. $\\frac{1}{2}$ × $\\frac{4}{4}$ = $\\frac{4}{8}$. $\\frac{2}{3}$ × $\\frac{2}{2}$ = $\\frac{4}{6}$. $\\frac{3}{4}$ × $\\frac{2}{2}$ = $\\frac{6}{8}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_uitbreiden_equivalence_match",
      "variantIndex": 9,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "hasStructuredData": true
      },
      "feedback": {
        "explanationText": "Bij uitbreiden vermenigvuldig je teller én noemer met hetzelfde getal. $\\frac{1}{2}$ = $\\frac{4}{8}$ (× 4). $\\frac{2}{3}$ = $\\frac{4}{6}$ (× 2). $\\frac{3}{4}$ = $\\frac{6}{8}$ (× 2). De waarde van elke breuk blijft gelijk.",
        "solutionSteps": [
          "$\\frac{1}{2}$ → noemer × 4 = 8 → teller 1 × 4 = 4 → $\\frac{4}{8}$",
          "$\\frac{2}{3}$ → noemer × 2 = 6 → teller 2 × 2 = 4 → $\\frac{4}{6}$",
          "$\\frac{3}{4}$ → noemer × 2 = 8 → teller 3 × 2 = 6 → $\\frac{6}{8}$"
        ]
      }
    }
  ]
}
